import React from 'react';
import { HashRouter, Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ChakraProvider } from '@chakra-ui/react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import AuthLayout from 'layouts/Auth';
import AdminLayout from 'layouts/Admin.js';
import RTLLayout from 'layouts/RTL.js';
import SiteLayout from 'layouts/Site';
import LegalLayout from 'views/Legal/LegalLayout';

// Custom Chakra theme
import theme from 'theme/theme.js';
import { UserProvider } from 'context/UserContext';
import { ConfirmProvider } from 'components/Confirm';
import { LanguageProvider } from 'i18n';

import '@trendmicro/react-paginations/dist/react-paginations.css';
import './styles/globals.css';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      retry: 0,
      // staleTime: 0 trước đây vô hiệu hoá toàn bộ cache react-query → mỗi lần
      // mount/điều hướng lại refetch. 60s cho phép tái dùng cache giữa các lần
      // chuyển trang; query cần realtime tự override staleTime nhỏ hơn.
      staleTime: 60 * 1000,
    },
  },
});

const App = () => {
  return (
    <ChakraProvider theme={theme} resetCss={false} position="relative">
      <GoogleOAuthProvider clientId="106445536051-5gqc5t2um3ouil93km7uut2arldjm93n.apps.googleusercontent.com">
        <QueryClientProvider client={client}>
          <LanguageProvider>
            <UserProvider>
              <BrowserRouter>
                <Switch>
                  {/* Public legal pages — no auth required so platform reviewers can read.
                      /privacy-policy + /terms-of-service là URL clean (không chứa "tiktok") submit cho TikTok review. */}
                  <Route
                    path={['/legal', '/privacy-policy', '/terms-of-service']}
                    component={LegalLayout}
                  />
                  <Route path={`/auth`} component={AuthLayout} />
                  <Route path={`/admin`} component={AdminLayout} />
                  <Route path={`/rtl`} component={RTLLayout} />
                  <Route
                    exact
                    path={['/', '/integrations', '/integrations/:slug']}
                    component={SiteLayout}
                  />
                  <Redirect to="/" />
                </Switch>
                <ConfirmProvider />
              </BrowserRouter>
            </UserProvider>
          </LanguageProvider>
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ChakraProvider>
  );
};

export default App;
